import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ClauseType} from 'app/fragment/types';
import {TdifClause} from '../tdif-types';

@Component({
  selector: 'cars-tdif-clause',
  templateUrl: './tdif-clause.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TdifClauseComponent {
  @Input() public content: TdifClause;

  constructor() {}

  public getClauseClass(clauseType: ClauseType): ClauseType {
    return ClauseType[clauseType];
  }
}
